import axios from '../../http'

class DBSiteLog {
  // 获取所有用户的操作日志
  getUserRecordList(currentPage) {
    const url = `/api/db/get/all?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取登录日志列表
  getLoginLogList(userId, currentPage) {
    const url = `/api/login/log/get/id?currentPage=${currentPage}&userId=${userId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取操作记录列表
  getOperationRecordList(userId, currentPage) {
    const url = `/api/log/get/id?currentPage=${currentPage}&userId=${userId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据日期查询登录日志
  getLoginLogByTime(userId, currentPage, startTime, endTime) {
    const url = `/api/login/log/query?currentPage=${currentPage}&userId=${userId}&start=${startTime}&end=${endTime}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 根据日期查询操作日志
  getOperationLogByTime(userId, currentPage, startTime, endTime) {
    const url = `/api/log/query?currentPage=${currentPage}&userId=${userId}&start=${startTime}&end=${endTime}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBSiteLog
